import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const TopRatedMassageCentersHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Top Rated Massage Centers</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default TopRatedMassageCentersHeader;
